'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAudioContext = exports.browser = exports.gaussian = exports.shuffle = exports.randsign = exports.randrange = exports.randint = exports.quantize = exports.xor = exports.dist = exports.angle = exports.lerp = exports.mod = exports.choice = exports.clamp = undefined;

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _startAudioContext = require('./startAudioContext');

var _startAudioContext2 = _interopRequireDefault(_startAudioContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIphone = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
var isIpad = navigator.userAgent.match(/iPad/i);
var isAndroid = navigator.userAgent.match(/Android/i);
var isMobile = isIphone || isIpad || isAndroid;
var isDesktop = !isMobile;

document.body.classList.add(isMobile ? 'mobile' : 'desktop');

var browser = { isIphone: isIphone, isIpad: isIpad, isAndroid: isAndroid, isMobile: isMobile, isDesktop: isDesktop };

function clamp(n, a, b) {
  return n < a ? a : n < b ? n : b;
}
function choice(a) {
  return a[Math.floor(Math.random() * a.length)];
}
function mod(n, m) {
  return n - m * Math.floor(n / m);
}
function randint(n) {
  return Math.random() * n | 0;
}
function randrange(a, b) {
  return a + Math.random() * (b - a);
}
function randsign() {
  return Math.random() >= 0.5 ? -1 : 1;
}
function lerp(n, a, b) {
  return (b - a) * n + a;
}
function angle(x0, y0, x1, y1) {
  return Math.atan2(y1 - y0, x1 - x0);
}
function dist(x0, y0, x1, y1) {
  return Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2));
}
function xor(a, b) {
  a = !!a;b = !!b;return (a || b) && !(a && b);
}
function quantize(a, b) {
  return Math.floor(a / b) * b;
}
function shuffle(a) {
  for (var i = a.length; i > 0; i--) {
    var r = randint(i);
    var swap = a[i - 1];
    a[i - 1] = a[r];
    a[r] = swap;
  }
  return a;
}
// returns a gaussian random function with the given mean and stdev.
function gaussian(mean, stdev) {
  var y2 = void 0;
  var use_last = false;
  return function () {
    var y1 = void 0;
    if (use_last) {
      y1 = y2;
      use_last = false;
    } else {
      var x1 = void 0,
          x2 = void 0,
          w = void 0;
      do {
        x1 = 2.0 * Math.random() - 1.0;
        x2 = 2.0 * Math.random() - 1.0;
        w = x1 * x1 + x2 * x2;
      } while (w >= 1.0);
      w = Math.sqrt(-2.0 * Math.log(w) / w);
      y1 = x1 * w;
      y2 = x2 * w;
      use_last = true;
    }

    var retval = mean + stdev * y1;
    if (retval > 0) return retval;
    return -retval;
  };
}

function requestAudioContext(fn) {
  if (isMobile) {
    var container = document.createElement('div');
    var button = document.createElement('div');
    button.innerHTML = 'Tap to start - please unmute your phone';
    Object.assign(container.style, {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: '10000',
      top: '0px',
      left: '0px',
      backgroundColor: 'rgba(0, 0, 0, 0.8)'
    });
    Object.assign(button.style, {
      display: 'block',
      position: 'absolute',
      left: '50%',
      top: '50%',
      padding: '20px',
      backgroundColor: '#7F33ED',
      color: 'white',
      fontFamily: 'monospace',
      borderRadius: '3px',
      transform: 'translate3D(-50%,-50%,0)',
      textAlign: 'center',
      lineHeight: '1.5',
      width: '150px'
    });
    container.appendChild(button);
    document.body.appendChild(container);
    _startAudioContext2.default.setContext(_tone2.default.context);
    _startAudioContext2.default.on(button);
    _startAudioContext2.default.onStarted(function (_) {
      container.remove();
      fn();
    });
  } else {
    fn();
  }
}

exports.clamp = clamp;
exports.choice = choice;
exports.mod = mod;
exports.lerp = lerp;
exports.angle = angle;
exports.dist = dist;
exports.xor = xor;
exports.quantize = quantize;
exports.randint = randint;
exports.randrange = randrange;
exports.randsign = randsign;
exports.shuffle = shuffle;
exports.gaussian = gaussian;
exports.browser = browser;
exports.requestAudioContext = requestAudioContext;


//////////////////
// WEBPACK FOOTER
// ./client/lib/util.js
// module id = 17
// module chunks = 0